// extracted by mini-css-extract-plugin
module.exports = {"filtersCollapse":"FilterContainer_filtersCollapse__1hPIA"};